import { render, staticRenderFns } from "./RelatedCanteen.vue?vue&type=template&id=2be2ca0b&"
import script from "./RelatedCanteen.vue?vue&type=script&lang=js&"
export * from "./RelatedCanteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports